module.exports = __webpack_public_path__ + "static/media/esagono.d9ef7ef1.svg";